<style scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
.search-indicator{
  margin-top: 5px;
  text-align: center;
}
.create-group{
  background: #fff;
  padding: 10px;
  border-bottom: 1px solid #eee;
}
.create-group > .action-button{
  width: 100%;
}
</style>

<template>
  <div class="resource-list-item-component">
    <Card shadow :padding="10" :style="{borderRadius: '0'}" v-if="userStuffs.careplans > 0">
      <Input @on-change="debounceInput(searchValue)" v-model="searchValue"
        icon="ios-search" placeholder="Search" />
      <p class="search-indicator" v-if="isLoadingSearch">Searching...</p>
    </Card>
    <div class="create-group" v-if="false">
      <Button type="default" icon="plus" class="action-button"
        v-on:click="reRouteCreateGroup">Create Group</Button>
    </div>
    <div class="resource-item-container">
      <div class="resource-body" v-for="(stuff, indx) in userStuffs.careplans" v-if="stuff.careplan.is_approved && stuff.careplan.type!='report_concern' && stuff.careplan.type!='suggestion_box' && stuff.careplan.type!='menu' && stuff.careplan.type!='video' && stuff.careplan.type!='maintainance'" :key="indx">
        <div v-if="!stuff.careplan">
          <FeedListView :avatar="groupDisplayImage(stuff)"
            :title="stuff.title"
            :item="stuff"
            :poster="stuff.careplan.type"
            @emitContainer="onTriggerStuff(stuff)"></FeedListView>
        </div>
        <div v-if="stuff.careplan">
          <div>
            <FeedListView :avatar="stuff.careplan.thumbnail_photo"
              :title="stuff.careplan.title"
              :item="stuff"
              :poster="stuff.careplan.type"
              @emitContainer="onTriggerStuff(stuff)"></FeedListView>
          </div>
        </div>
      </div>
    </div>
    <Spin style="margin: 20px 0;" v-if="isLoadingLoadMore">
      <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import FeedListView from "@/components/FeedListView";
import _ from "lodash";
import WindowScrollEvent from 'vue-scroll-event/mixins/WindowOnScroll'
import Utils from '@/utils.js'

export default {
  name: "ResourceListItemComponent",
  mixins: [WindowScrollEvent],
  components: {
    FeedListView
  },
  data(){
    return {
      searchValue: '',
    }
  },
  computed: {
    userStuffs: {
      get() {
        return this.$store.state.user.userStuffs;
      }
    },
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    isLoadingLoadMore: {
      get() {
        return this.$store.state.user.isLoadingLoadMore;
      }
    },
    isLoadingSearch: {
      get() {
        return this.$store.state.user.isLoadingSearch
      }
    }
  },
  mounted() {
    console.log("test")
    if (_.isEmpty(this.$store.state.user.info)) {
      this.$store.dispatch("user/getUserInfo").then(res => {
        this.$store.dispatch("user/getUserStuffs", this.profileInfo.journal_id);
      });
    }else{
        if (_.isEmpty(this.userStuffs)){
          // console.log(_.isEmpty(this.userStuffs))
          // if(this.userStuffs.careplans.length > 0){
            // this.$store.dispatch("user/getUserStuffs", this.profileInfo.journal_id);
          // }
        }
        this.$store.dispatch("user/getUserStuffs", this.profileInfo.journal_id);
    }
  },
  methods: {
    groupDisplayImage(stuff) {
      return Utils.getDisplayImage('group', stuff, 'small')
    },
    onWindowScrolledBottom () {
    },
    onTriggerStuff(data) {      
      if(data.careplan_id)
        this.$router.push({ path: "/resources/" + data.careplan_id});
      else
        this.$router.push({ path: "/resources/" + data.id});
    },
    reRouteCreateGroup(){
      this.$router.push({ path: 'create-group' });
    },
    debounceInput: _.debounce(function (search_data) {
      this.$store.dispatch("user/serachUserStuffs", { journal_id: this.profileInfo.journal_id, search: search_data })
    }, 500)
  }
};
</script>
